import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { initPerson } from "../../redux/person/personLegalSlice";
import { usePersonLegalForm } from "../../hooks/person/usePersonLegalForm"
import PersonLegalFormBody from "../../components/person/PersonLegalFormBody"
import PageHeader from "../../components/common/PageHeader"
import SaveButtonBar from "../../components/common/SaveButtonBar"

const EditLegal = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const sliceKey = "personEditLegal";

  useEffect(() => {
      dispatch(initPerson({ sliceKey: sliceKey }));
  }, [dispatch, sliceKey]);

  const fetchOpen = useCallback(async () => {
    setIsReadOnly(false)
  }, [props.openClose])

  useEffect(() => {
    fetchOpen();
  }, [])

  const {
    isReadOnly,
    setIsReadOnly,
    idNew,
    save
  } = usePersonLegalForm(sliceKey, {
    useBonding: true
  });

  return (
    <div>
      <PageHeader
        title={(params.id == 0 ? "Nueva" : "Editar") + " Persona Juridica"}
        backTo="/person"
      />

      <SaveButtonBar
        onClick={save}
        disabled={isReadOnly}
      />

      <PersonLegalFormBody
        sliceKey={sliceKey}
        id={params.id}
        hideInputs={false}
        isReadOnly={isReadOnly}
      />

      <SaveButtonBar
        onClick={save}
        disabled={isReadOnly}
      />
    </div>
  )
}

export default EditLegal
